import React from 'react';
function doesExist(rowId) {
  return rowId !== null && rowId !== undefined;
}
let getObjectChildren;
const checkString = value => {
  let string = value.toString().toLowerCase();
  if (string === '[object object]') {
    string = getObjectChildren(value);
  }
  return string.toString();
};
getObjectChildren = value => {
  let string = '';
  const kids = value.props.children;
  if (Array.isArray(kids)) {
    kids.forEach(k => {
      const subString = checkString(k);
      string += subString;
    });
  } else {
    string = kids;
  }
  return string;
};
function checkValue(filter, value) {
  let string = checkString(value).toString().toLowerCase();
  let filterValue = filter.value.toString().toLowerCase();
  if (filter.id === 'release_number') {
    string = string.replace(/[ -]/g, '');
    filterValue = filterValue.replace(/[ -]/g, '');
  }
  return string.includes(filterValue);
}
function checkArray(rowId, filter) {
  let found = false;
  rowId.some(value => {
    found = checkValue(filter, value);
    return found === true;
  });
  return found;
}
function checkThis(row, id, filter) {
  let found = false;
  if (Array.isArray(row[id])) {
    found = checkArray(row[id], filter);
  } else {
    found = checkValue(filter, row[id]);
  }
  return found;
}
export const wmDefaultTableFilter = (filter, row) => {
  const id = filter.pivotId || filter.id;
  let found = false;
  if (doesExist(row[id])) {
    found = checkThis(row, id, filter);
  } else {
    found = false;
  }
  return found;
};
export const basicDropdownFilter = (filter, onChange, hash) => {
  const options = Object.entries(hash).map((entry, idx) => /*#__PURE__*/React.createElement("option", {
    key: "opt_".concat(idx + 10),
    value: entry[0]
  }, entry[1]));
  return /*#__PURE__*/React.createElement("select", {
    onChange: event => onChange(event.target.value),
    style: {
      width: '100%'
    },
    filter: filter,
    value: filter ? filter.value : '%'
  }, options);
};
export const ActiveFilterOptions = (filter, onChange) => {
  const options = {
    all: 'All',
    active: 'Active',
    inactive: 'Inactive'
  };
  return basicDropdownFilter(filter, onChange, options);
};
export const ActiveFilterMethod = (filter, row) => {
  let match;
  switch (filter.value) {
    case 'active':
      match = row[filter.id] === 'Active';
      break;
    case 'inactive':
      match = row[filter.id] === 'Inactive';
      break;
    case 'all':
    default:
      match = true;
  }
  return match;
};
function rangeFilter(type, filter, onChange) {
  const filterValue = filter ? filter.value || [] : [];
  return /*#__PURE__*/React.createElement("div", null, "Start", /*#__PURE__*/React.createElement("input", {
    value: filterValue[0] || '',
    type: type,
    onChange: e => {
      let newVal = e.target.value || '';
      if (type === 'number' && newVal) {
        newVal = parseFloat(newVal);
      }
      onChange([newVal, filterValue[1]]);
    },
    placeholder: "Min",
    style: {
      width: '140px',
      height: '2.2em',
      marginLeft: '0.5rem'
    }
  }), /*#__PURE__*/React.createElement("br", null), "End", /*#__PURE__*/React.createElement("input", {
    value: filterValue[1] || '',
    type: type,
    onChange: e => {
      let newVal = e.target.value || '';
      if (type === 'number' && newVal) {
        newVal = parseFloat(newVal);
      }
      onChange([filterValue[0], newVal]);
    },
    placeholder: "Max",
    style: {
      width: '140px',
      height: '2.2em',
      marginLeft: '0.8rem'
    }
  }));
}
export const NumberRangeTableFilter = (filter, onChange) => rangeFilter('number', filter, onChange);
export const DateRangeTableFilter = (filter, onChange) => rangeFilter('date', filter, onChange);
export default {
  Default: wmDefaultTableFilter,
  BasicDropdownFilter: basicDropdownFilter,
  NumberRangeTableFilter,
  DateRangeTableFilter,
  ActiveFilterOptions,
  ActiveFilterMethod
};